// extracted by mini-css-extract-plugin
module.exports = {"slide":"DialogPaidConfirm_slide_3Zgtf","slide-reverse":"DialogPaidConfirm_slide-reverse_iKBnp"};